import { z } from 'zod'
import { ROLES } from '../rbac.js'

export const roleSchema = z.enum(ROLES)

/**
 * Senha minima de 10 caracteres. Sem exigencia de simbolo: regras barrocas
 * empurram equipe de secretaria para o post-it na tela, o que piora a
 * seguranca real. Comprimento e o que efetivamente protege.
 */
export const passwordSchema = z
  .string()
  .min(10, 'A senha deve ter ao menos 10 caracteres')
  .max(200, 'Senha muito longa')

export const loginSchema = z.object({
  email: z.email('Informe um e-mail valido').toLowerCase().trim(),
  password: z.string().min(1, 'Informe a senha'),
})

export type LoginInput = z.infer<typeof loginSchema>

export const forgotPasswordSchema = z.object({
  email: z.email('Informe um e-mail valido').toLowerCase().trim(),
})

export const resetPasswordSchema = z
  .object({
    token: z.string().min(1, 'Token obrigatorio'),
    password: passwordSchema,
    passwordConfirmation: z.string().min(1, 'Confirme a senha'),
  })
  .refine((data) => data.password === data.passwordConfirmation, {
    path: ['passwordConfirmation'],
    error: 'As senhas nao conferem',
  })

export const changePasswordSchema = z
  .object({
    currentPassword: z.string().min(1, 'Informe a senha atual'),
    password: passwordSchema,
    passwordConfirmation: z.string().min(1, 'Confirme a senha'),
  })
  .refine((data) => data.password === data.passwordConfirmation, {
    path: ['passwordConfirmation'],
    error: 'As senhas nao conferem',
  })

export const createUserSchema = z.object({
  name: z.string().min(3, 'Informe o nome completo').max(160).trim(),
  email: z.email('Informe um e-mail valido').toLowerCase().trim(),
  role: roleSchema,
  password: passwordSchema,
  active: z.boolean().default(true),
})

export const updateUserSchema = createUserSchema
  .omit({ password: true })
  .partial()
  .extend({ password: passwordSchema.optional() })

export type CreateUserInput = z.infer<typeof createUserSchema>
export type UpdateUserInput = z.infer<typeof updateUserSchema>
